// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"783":"ba1f1425","921":"ba1f1425"}[chunkId] + ".chunk.css";
};